import { render } from "./DefaultCheckbox.vue?vue&type=template&id=142b9894&scoped=true"
import script from "./DefaultCheckbox.vue?vue&type=script&lang=js"
export * from "./DefaultCheckbox.vue?vue&type=script&lang=js"

import "./DefaultCheckbox.vue?vue&type=style&index=0&id=142b9894&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-142b9894"]])

export default __exports__